import React, { useState } from "react";
import Row from "../../common/Row";
import { useTranslation } from "react-i18next";

const ButtonSwitch = () => {
  const [activeButton, setActiveButton] = useState(1);
  const { t } = useTranslation("education");

  const buttonTexts = [
    <div>
      <div className="text-sm">{t("classes.buttons.b1.age")}</div>
      {t("classes.buttons.b1.label")}
    </div>,
    <div>
      <div className="text-sm">{t("classes.buttons.b2.age")}</div>
      {t("classes.buttons.b2.label")}
    </div>,
    <div>
      <div className="text-sm">{t("classes.buttons.b3.age")}</div>
      {t("classes.buttons.b3.label")}
    </div>,
    <div>
      <div className="text-sm">{t("classes.buttons.b4.age")}</div>
      {t("classes.buttons.b4.label")}
    </div>,
  ];

  const texts = [
    // --- Class 1 ---
    <div className="border-2 border-emerald-400 rounded-xl bg-gray-100 text-left p-8 m-4">
      <div className="text-emerald-400 text-lg">{t("classes.c1.title")}</div>
      <div>
        {t("classes.c1.body1")}
        <br />
        <br />
        {t("classes.c1.studyPlan")}
        <br />
        <br />
        {t("classes.c1.s1")}
        <br />
        {t("classes.c1.s2")}
        <br />
        {t("classes.c1.s3")}
        <br />
        {t("classes.c1.s4")}
        <br />
      </div>
    </div>,

    // --- Class 2 ---
    <div className="border-2 border-emerald-400 rounded-xl bg-gray-100 text-left p-8 m-4">
      <div className="text-emerald-400 text-lg">{t("classes.c2.title")}</div>
      <div>
        {t("classes.c2.body1")}
        <br />
        <br />
        {t("classes.c2.studyPlan")}
        <br />
        <br />
        {t("classes.c2.s1")}
        <br />
        {t("classes.c2.s2")}
        <br />
        {t("classes.c2.s3")}
        <br />
        {t("classes.c2.s4")}
        <br />
        {t("classes.c2.s5")}
        <br />
        {t("classes.c2.s6")}
        <br />
        {t("classes.c2.s7")}
        <br />
      </div>
    </div>,

    // --- Class 3 ---
    <div className="border-2 border-emerald-400 rounded-xl bg-gray-100 text-left p-8 m-4">
      <div className="text-emerald-400 text-lg">{t("classes.c3.title")}</div>
      <div>
        {t("classes.c3.studyContent")}
        <br />
        <br />
        {t("classes.c3.s1")}
        <ul className="list-disc">
          <li>{t("classes.c3.s1_1")}</li>
          <li>{t("classes.c3.s1_2")}</li>
        </ul>
        {t("classes.c3.s2")}
        <br />
        <ul className="list-disc">
          <li>{t("classes.c3.s2_1")}</li>
          <li>{t("classes.c3.s2_2")}</li>
        </ul>
        {t("classes.c3.s3")}
        <br />
        <ul className="list-disc">
          <li>{t("classes.c3.s3_1")}</li>
        </ul>
        {t("classes.c3.s4")}
        <br />
        <ul className="list-disc">
          <li>{t("classes.c3.s4_1")}</li>
        </ul>
      </div>
    </div>,

    // --- Class 4 ---
    <div className="border-2 border-emerald-400 rounded-xl bg-gray-100 text-left p-8 m-4">
      <div className="text-emerald-400 text-lg">{t("classes.c4.title")}</div>
      <div>
        {t("classes.c4.body1")}
        <br />
        <br />
        {t("classes.c4.study")}
        <br />
        <br />
        {t("classes.c4.s1")}
        <br />
        {t("classes.c4.s2")}
        <br />
        {t("classes.c4.s3")}
        <br />
        {t("classes.c4.s4")}
        <br />
        {t("classes.c4.s5")}
        <br />
        {t("classes.c4.s6")}
        <br />
      </div>
    </div>,
  ];

  return (
    <div>
      <Row>
        {[1, 2, 3, 4].map((buttonIndex) => (
          <div
            key={`switch-${buttonIndex}`}
            onClick={() => setActiveButton(buttonIndex)}
            className={`rounded-lg m-2 p-2 md:w-48 ${
              activeButton === buttonIndex
                ? "bg-gray-300 text-black"
                : "bg-emerald-600 text-white"
            }`}
          >
            {buttonTexts[buttonIndex - 1]}
          </div>
        ))}
      </Row>

      {texts[activeButton - 1]}
    </div>
  );
};

export default ButtonSwitch;
